'use client';

import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { UnauthQueryOptions } from '@/api';
import { SearchSideAdBanner } from '@/app/_components/ads';
import { DesktopPageShell } from '@/components/template/DesktopPageShell';
import type { DonationBusinessSort } from '../../_hooks/useIntegratedSearchFilter';
import { PAGE_SIZE } from '../../constants';
import { buildPaginationMeta } from '../../utils';
import { SearchSectionShell } from '../SearchSectionShell';
import { DonationBusinessList } from './DonationBusinessList';
import { DonationFilter } from './DonationFilter';
import { DonationSortDropdown } from './DonationSortDropdown';
import { SearchDonationSkeletonList } from './SearchDonationCardSkeleton';
interface DonationBusinessSearchProps {
  keyword: string;
  page: number;
  onPageChange: (page: number) => void;
  isFilterOpen: boolean;
  onCloseFilter: () => void;
  institutionIds: number[];
  sort: DonationBusinessSort;
  onToggleInstitution: (id: number) => void;
  onSortChange: (sort: DonationBusinessSort) => void;
  onReset: () => void;
}
export function DonationBusinessSearch(t0) {
  const $ = _c(31);
  const {
    keyword,
    page,
    onPageChange,
    isFilterOpen,
    onCloseFilter,
    institutionIds,
    sort,
    onToggleInstitution,
    onSortChange,
    onReset
  } = t0;
  let t1;
  if ($[0] !== institutionIds || $[1] !== keyword || $[2] !== page || $[3] !== sort) {
    t1 = UnauthQueryOptions["get:/wello/v2/allows/query/donations-businesses"]({
      query: {
        searchKeyword: keyword,
        institutionIds: institutionIds.length > 0 ? institutionIds : undefined,
        sortType: sort,
        page,
        size: PAGE_SIZE
      }
    });
    $[0] = institutionIds;
    $[1] = keyword;
    $[2] = page;
    $[3] = sort;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = {
      ...t1,
      placeholderData: keepPreviousData
    };
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    data,
    isLoading
  } = useQuery(t2);
  const t3 = data?.context?.totalCount ?? 0;
  let t4;
  if ($[7] !== t3) {
    t4 = buildPaginationMeta(t3);
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const meta = t4;
  let t5;
  if ($[9] !== institutionIds || $[10] !== isFilterOpen || $[11] !== onCloseFilter || $[12] !== onReset || $[13] !== onToggleInstitution) {
    t5 = <DonationFilter isDrawerOpen={isFilterOpen} onCloseDrawer={onCloseFilter} onApplyDrawer={onCloseFilter} institutionIds={institutionIds} onToggleInstitution={onToggleInstitution} onReset={onReset} />;
    $[9] = institutionIds;
    $[10] = isFilterOpen;
    $[11] = onCloseFilter;
    $[12] = onReset;
    $[13] = onToggleInstitution;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SearchSideAdBanner />;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== onSortChange || $[17] !== sort) {
    t7 = <DonationSortDropdown sort={sort} onSortChange={onSortChange} />;
    $[16] = onSortChange;
    $[17] = sort;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== data?.context?.contents || $[20] !== isLoading) {
    t8 = isLoading ? <SearchDonationSkeletonList count={PAGE_SIZE} /> : <DonationBusinessList items={data?.context?.contents ?? []} />;
    $[19] = data?.context?.contents;
    $[20] = isLoading;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== meta || $[23] !== onPageChange || $[24] !== page || $[25] !== t7 || $[26] !== t8) {
    t9 = <SearchSectionShell meta={meta} page={page} pageSize={PAGE_SIZE} onPageChange={onPageChange} header={t7}>{t8}</SearchSectionShell>;
    $[22] = meta;
    $[23] = onPageChange;
    $[24] = page;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== t5 || $[29] !== t9) {
    t10 = <DesktopPageShell className="mt-20 w-full mobile-tablet:mt-0" leftAside={t5} rightAside={t6}>{t9}</DesktopPageShell>;
    $[28] = t5;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  return t10;
}